import { apiFetch } from './apiFetch';
import { ensureCsrfToken } from './publicApi';

const API_BASE = process.env.REACT_APP_API_URL;

export async function requestNomineePassword(email) {
  await ensureCsrfToken();
  const res = await apiFetch(`${API_BASE}/nominee/request-password`, {
    method: 'POST',
    body: JSON.stringify({ email })
  });
  return res.json();
}

export async function nomineeLogin(email, password) {
  await ensureCsrfToken();
  const res = await apiFetch(`${API_BASE}/nominee/login`, {
    method: 'POST',
    body: JSON.stringify({ email, password })
  });
  return res.json();
}

export async function getUserById(userId) {
  const res = await apiFetch(`${API_BASE}/nominee/user/${userId}`);
  return res.json();
}

// The nominee's answer to the designation notice (DPDP §5, finding F4). No session and
// no account: the token from their email is the whole credential, because requiring
// either would mean making someone sign up with us - or wait for a password sent to the
// very address they are objecting to us holding - before they could say no.
//
// ensureCsrfToken() is still called. csrfProtection only enforces the double-submit when
// a session cookie is present, so an ordinary objector needs none; but the objector who
// happens to be logged in here for their own account does, and this way the same call
// works for both rather than failing for the one case nobody would test.
export async function objectToNomination(id, token) {
  await ensureCsrfToken();
  const res = await apiFetch(`${API_BASE}/nominee/object`, {
    method: 'POST',
    body: JSON.stringify({ id: Number(id), token })
  });
  return res.json();
}
